import toast from 'react-hot-toast';

import QuizUtilityService from '@/services/course/lesson/quiz-utility-service';
import { SubunitId, UnitId } from 'course-types';
import { SavedFR, SavedMC } from 'quiz-types';

const RouteGuardCallbacks = {
  async incompleteQuizCallback(
    cId: any,
    uId: UnitId | undefined,
    sId: SubunitId | undefined,
    qId: string,
    criticalData: any,
  ) {
    if (!criticalData) {
      console.error('Critical data is undefined');
      return;
    }

    // Attempt to update existing quiz attempt with current progress
    const currentMC: Record<number, SavedMC> = {};
    const currentFR: Record<number, SavedFR> = {};
    for (const question of criticalData?.questionSet ?? []) {
      const answer = (criticalData?.backupAnswers ?? {})[question.index];
      if (question.type == 'Multiple Choice') {
        if (answer !== undefined) currentMC[question.index] = { answerChosen: answer };
      } else {
        currentFR[question.index] = { response: answer };
      }
    }
    const res = await QuizUtilityService.updateQuizAttempt(
      qId,
      currentMC,
      currentFR,
      criticalData.backupStart,
    );

    // success
    if (res) {
      toast.success('Incomplete quiz attempt saved.');
    }
  },
};

export default RouteGuardCallbacks;
